import React, { forwardRef } from 'react';

import { Table as PTable, type TableProps } from '../../ui/primitives/table';

/**
 * __Table__
 *
 * A data table is used to display dynamic data.
 *
 * - [Examples](https://atlassian.design/components/table/examples)
 */
export const Table = forwardRef<HTMLTableElement, TableProps>(
	({ children, testId, xcss: customXcss, ...props }, ref) => {
		return (
			<PTable testId={testId} xcss={customXcss} ref={ref} {...props}>
				{children}
			</PTable>
		);
	},
);
